import { Navigate, useParams } from 'react-router'

import AppFooter from '../components/layout/AppFooter'
import AppHeader from '../components/layout/AppHeader'
import Shell from '../components/layout/Shell'
import VerificationIdentityEditCard from '../components/verification/VerificationIdentityEditCard'
import {
  CONTACT_VERIFICATION_EMAIL_VALIDATED_KEY,
  CONTACT_VERIFICATION_ENTRY_TOKEN_KEY,
  CONTACT_VERIFICATION_PHONE_VALIDATED_KEY,
  CONTACT_VERIFICATION_PROCESS_STATUS_KEY,
  CONTACT_VERIFICATION_TOKEN_KEY,
  getItemFromLS,
} from '../core/api'

export default function VerificationIdentityEditPage() {
  const { verificationToken = '' } = useParams()
  const hasActiveSession =
    getItemFromLS(CONTACT_VERIFICATION_ENTRY_TOKEN_KEY) === verificationToken &&
    getItemFromLS(CONTACT_VERIFICATION_TOKEN_KEY)

  if (hasActiveSession && getItemFromLS(CONTACT_VERIFICATION_PROCESS_STATUS_KEY)) {
    return <Navigate to={`/verify/${verificationToken}/status`} replace />
  }

  if (
    !hasActiveSession ||
    !getItemFromLS(CONTACT_VERIFICATION_EMAIL_VALIDATED_KEY) ||
    !getItemFromLS(CONTACT_VERIFICATION_PHONE_VALIDATED_KEY)
  ) {
    return <Navigate to={`/verify/${verificationToken}/review`} replace />
  }

  return (
    <Shell>
      <AppHeader />
      <VerificationIdentityEditCard />
      <AppFooter />
    </Shell>
  )
}
